import { useGlobal } from '../../context/GlobalContext';
import { getStrapiMediaAttributes } from '../../lib/strapi';
import useScrollReveal from '../../hooks/useScrollReveal';
import { getIconFallbackLabel } from '../../lib/uiText';
import styles from './MainFeatures.module.css';

const MainFeatures = ({ data }) => {
  const { locale } = useGlobal();
  const features = data?.features || [];
  const [ref, isVisible] = useScrollReveal({ threshold: 0.2 });

  if (!features.length) return null;

  return (
    <section 
      ref={ref}
      className={`${styles.mainFeatures} ${isVisible ? styles['mainFeatures--visible'] : ''}`}
    >
      {features.slice(0, 3).map((feature, index) => {
        const iconMedia = feature?.icon?.url
          ? getStrapiMediaAttributes(feature.icon, {
            altFallback: getIconFallbackLabel(locale, 'feature', feature.label),
            titleFallback: getIconFallbackLabel(locale, 'feature', feature.label),
          })
          : null;

        return (
          <div 
            key={feature.id || index} 
            className={styles.mainFeatures__item}
            style={{ transitionDelay: `${index * 0.1}s` }}
          >
            {iconMedia?.src && (
              <img
                src={iconMedia.src}
                alt={iconMedia.alt}
                title={iconMedia.title}
                className={styles.mainFeatures__icon}
              />
            )}
            <span className={styles.mainFeatures__label}>{feature.label}</span>
          </div>
        );
      })}
    </section>
  );
};

export default MainFeatures;
